export default "/images/vendor/flag-icon-css/flags/1x1/pa.svg?751c8f87270b925c26c412ec7620827f";